import { Box, Dialog, DialogContent } from "@mui/material";
import { useGetAccess, useGetGAAccess } from "./api/hooks";
import { ModalTransition } from "../../../common/components/transitions";
import StyledDialogTitle from "../../../common/components/dialog/dialog-title";
import { Actions } from "./components/actions";
import { Modules } from "./components/content";
import { UnsavedChangesDialog } from "../../../common/components/unsaved-changes-dialog";
import { Handlers } from "../api/handlers";
import useAccessibilityModalStore from "./store";
import { useParams } from "react-router-dom";

type Props = {};

const ManageAccessModal: React.FC = (props: Props) => {
  const state = useAccessibilityModalStore();

  type Modes = "client" | "bizbox";

  const { mode } = useParams<{ mode: Modes }>();

  const isInternal = mode === "bizbox";
  const getAccess = useGetAccess(isInternal);
  const getGAAccess = useGetGAAccess(!isInternal);
  const { data: BRdata } = getAccess;

  const { data: GAdata } = getGAAccess;

  const handlers = new Handlers();
  return (
    <Dialog
      onClose={handlers.handleCloseAccessManagementModal}
      open={state.isManageAccessModalOpen}
      slots={{
        transition: ModalTransition,
      }}
      slotProps={{
        paper: {
          component: "form",
          // onSubmit: handleSubmit,
          sx: { borderRadius: "24px" },
        },
      }}
      maxWidth={"desktop"}
      fullWidth
      aria-describedby="alert-dialog-slide-description"
    >
      <StyledDialogTitle
        actionType="close"
        title="Manage Access"
        handleClose={handlers.handleCloseAccessManagementModal}
      />

      <DialogContent sx={{ minWidth: "50%", m: "16px" }}>
        <Actions
          role={
            isInternal ? BRdata?.role.displayName : GAdata?.role.displayName
          }
        />
        <Box sx={{ mb: "16px" }} />
        <Modules getAccess={isInternal ? getAccess : getGAAccess} />
      </DialogContent>

      <UnsavedChangesDialog
        onContinue={handlers.handleCloseAccessManagementModal}
      />
    </Dialog>
  );
};

export default ManageAccessModal;
